// web/src/marketing/MarketingLayout.tsx
//
// Shared chrome (Header + PublicFooter) for every public marketing route.
// Previously the Header was only rendered inside LandingPage, so clicking
// any nav link (e.g. "Pricing") left the user on an orphaned page with no
// way back. This layout fixes that by wrapping all marketing routes via
// the React Router layout-route pattern.
import { Outlet } from "react-router-dom";
import { Header } from "./sections/Header";
import { PublicFooter } from "@/shell/PublicFooter";

export function MarketingLayout() {
  return (
    <>
      <Header />
      <Outlet />
      <PublicFooter />
    </>
  );
}
